import { useState, useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import VendorRequestModel from "../../../models/company/vendor/request/VendorRequestModel";
import { OBJECT_NAME_RULE, EMAIL_RULE, MOBILE_NUMBER_RULE } from "../../../utils/validation-utils";
import dateUtils from "../../../utils/date-utils";
import toasterUtils from "../../../utils/toaster-utils";
import { GuidEnum } from "../../../models/enums/GuidEnum";
import { Button, FormControl, TextField } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";

interface VendorProps {
    objVendor: VendorRequestModel;
    actionType: string;
    onCloseVendor: () => void;
    onVendorSave: (objVendor: VendorRequestModel) => void;
}

const VendorCreateComponent = (props: VendorProps) => {
    const {
        register,
        control,
        handleSubmit,
        formState: { errors, isValid },
    } = useForm<VendorRequestModel>({
        mode: "onChange",
        defaultValues: {
            ...props.objVendor,
            startDate: props.objVendor.startDate ? (dayjs(props.objVendor.startDate) as any) : null,
            endDate: props.objVendor.endDate ? (dayjs(props.objVendor.endDate) as any) : null,
        },
    });

    const onSubmit = (formData: VendorRequestModel) => {
        if (!isValid) {
            toasterUtils.showError("Please fill all mandatory fields");
            return;
        }
        if (formData.startDate !== null && formData.endDate !== null) {
            if (formData.startDate > formData.endDate) {
                toasterUtils.showError("End Date should be greater than Start Date are Mandatory");
            } else {
                formData.vendorUserName = formData.vendorEmailId;
                //formData.startDate = startDate;
                //formData.endDate = endDate;
                formData.userId = GuidEnum.Empty;
                props.onVendorSave(formData);
            }
        } else {
            toasterUtils.showError("Start Date & End Date are Mandatory");
        }
    };

    return (
        <form className="contact quform" onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
                <div className="col-md-6">
                    <FormControl fullWidth margin="normal" error={!!errors.vendorName}>
                        <TextField label="Vendor Name" size="small" {...register("vendorName", OBJECT_NAME_RULE)} error={!!errors.vendorName}
                            helperText={errors.vendorName?.message} autoComplete="off" required />
                    </FormControl>
                </div>
                <div className="col-md-6">
                    <div className="quform-element form-group">
                        <div className="quform-input">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <Controller name="startDate" control={control} rules={{ required: "Start Date is required" }}
                                    render={({ field, fieldState }) => (
                                        <FormControl fullWidth margin="normal" error={!!fieldState.error}>
                                            <DatePicker
                                                label="Start Date"
                                                value={field.value}
                                                onChange={field.onChange}
                                                format="YYYY-MMM-DD"
                                                slotProps={{
                                                    textField: {
                                                        size: "small",
                                                        fullWidth: true,
                                                        error: !!fieldState.error,
                                                        helperText: fieldState.error?.message,
                                                        onKeyDown: (e) => e.preventDefault(),
                                                    },
                                                }}
                                            />
                                        </FormControl>
                                    )}
                                />
                            </LocalizationProvider>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6">
                    <FormControl fullWidth margin="normal" error={!!errors.vendorEmailId}>
                        <TextField type="email" label="Vendor Email" size="small" {...register("vendorEmailId", EMAIL_RULE)} error={!!errors.vendorEmailId}
                            helperText={errors.vendorEmailId?.message} autoComplete="off" disabled={props.objVendor.vendorId !== GuidEnum.Empty} required />
                    </FormControl>
                </div>
                <div className="col-md-6">
                    <div className="quform-element form-group">
                        <div className="quform-input">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <Controller name="endDate" control={control} rules={{ required: "End Date is required" }}
                                    render={({ field, fieldState }) => (
                                        <FormControl fullWidth margin="normal" error={!!fieldState.error}>
                                            <DatePicker
                                                label="End Date"
                                                value={field.value}
                                                onChange={field.onChange}
                                                format="YYYY-MMM-DD"
                                                slotProps={{
                                                    textField: {
                                                        size: "small",
                                                        fullWidth: true,
                                                        error: !!fieldState.error,
                                                        helperText: fieldState.error?.message,
                                                        onKeyDown: (e) => e.preventDefault(),
                                                    },
                                                }}
                                            />
                                        </FormControl>
                                    )}
                                />
                            </LocalizationProvider>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6">
                    <FormControl fullWidth margin="normal" error={!!errors.vendorPhoneNumber}>
                        <TextField type="text" label="Vendor Mobile No" size="small" {...register("vendorPhoneNumber", MOBILE_NUMBER_RULE)} error={!!errors.vendorPhoneNumber}
                            helperText={errors.vendorPhoneNumber?.message} autoComplete="off" required />
                    </FormControl>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12 text-end m-t-sm">
                    <Button variant="contained" color="success" type="submit" disabled={!isValid}>
                        Save
                    </Button>
                    <Button variant="contained" color="error" className="m-l-xxs" type="button" onClick={props.onCloseVendor}>
                        Close
                    </Button>
                </div>
            </div>
        </form>
    );
};
export default VendorCreateComponent;